module.exports = "/_next/static/images/hero-b48f78aae31cf3b012acb653af40f5ed.png";